import { useQuery } from "@tanstack/react-query";
import i18n from "i18n";
import { AIConfiguredModelProviders } from "@graylog/enterprise-api";
import { defaultOnError } from "util/conditional/onError";
import { MODEL_PROVIDERS_QUERY_KEY, toConfiguredModelProvider } from "./fetchModelProviders";
const useConfiguredModelProviders = ({ enabled = true } = {}) => {
  const { data, isLoading } = useQuery({
    queryKey: [...MODEL_PROVIDERS_QUERY_KEY, "all"],
    queryFn: () => defaultOnError(
      AIConfiguredModelProviders.listConfiguredProviders().then(
        ({ elements }) => elements.map(toConfiguredModelProvider)
      ),
      i18n.t("notifications.model_providers_load_message", { ns: "enterprise_ai" }),
      i18n.t("notifications.model_providers_load_title", { ns: "enterprise_ai" })
    ),
    enabled
  });
  return { data: data != null ? data : [], isLoading };
};
export default useConfiguredModelProviders;
